import { StateString } from '@witkac/kartamiejska-shared';

import { BenefitChangeState, BenefitChangeStateTranslation } from '@/enums/benefitChangeState';
import { BenefitTabs, BenefitTabsTranslation } from '@/enums/benefitTabs.enum';
import { baseFilters } from '@/utils/baseFilters';
import { BenefitTabsFilters } from '@/utils/constants';

export function benefitTabFilters(to: any, store: any): any {
  let filters: any = {
    ...baseFilters(to),
    state: StateString.NOT_CONFIRMED,
    withInactiveCategories: true,
    withShared: true
  };

  filters = { ...filters, ...(BenefitTabsFilters as any)[to.params.state] };

  store.commit('breadcrumbs/set', [
    { text: 'Usługi', to: { name: 'benefits' }, exact: true },
    {
      text: BenefitTabsTranslation[BenefitTabs[to.params.state as BenefitTabs]],
      disabled: true
    }
  ]);

  return filters;
}
